import React from 'react/addons';
import {gettext} from 'ofs/i18n';

const messages = {
  RATES_HEADER: gettext("About our rates"),
  RATES_QUIBBLE: gettext("No-quibble cool-off period"),
  RATES_QUIBBLE_DESCRIPTION: gettext("Provided you book more than seven days before the start of your stay, you can cancel your booking no questions asked within 24 hours of making it, and we will refund 100% of any charges."),
  RATES_STANDARD: gettext("Standard Rate"),
  RATES_STANDARD_DESCRIPTION: gettext("Our standard rate, best for those whose plans are unlikely to change. If you cancel up to 14 days before the start of your stay, we will refund 50% of your booking. If you cancel within two weeks of the start of your stay, we can't refund your booking. For our full cancellation policy,"),
  RATES_FLEXIBLE: gettext("Flexible Rate"),
  RATES_FLEXIBLE_DESCRIPTION: gettext("Our rate for those who'd like more flexibility. If you've selected the flexible rate you can cancel your booking at any point right up to 48 hours before the start of your stay and receive a full refund, less our flexibility fee. Once you're within 48 hours of the start of your stay, we can't refund your booking. For our full cancellation policy,"),
  RATES_CLICK: gettext("click here"),
};

const RatesGuideModal = React.createClass({
  render () {
    return (
      <div className="rates-guide">
        <h1>{messages.RATES_HEADER}</h1>
        <p><b>{messages.RATES_QUIBBLE}</b>. {messages.RATES_QUIBBLE_DESCRIPTION}</p>
        <p><b>{messages.RATES_STANDARD}</b>. {messages.RATES_STANDARD_DESCRIPTION} <a href="/cancellation-policy/">{messages.RATES_CLICK}</a>.</p>
        <p><b>{messages.RATES_FLEXIBLE}</b>. {messages.RATES_FLEXIBLE_DESCRIPTION} <a href="/cancellation-policy/">{messages.RATES_CLICK}</a>.</p>
      </div>
    );
  }
});

export default RatesGuideModal;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/components/RatesGuideModal.jsx
 **/